function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
Copyright (c) 2018-2020 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY
import * as React from 'react';
export default function FlagFO(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURfz8/PX19RJvx/Pz8+81R/Hx8RZ20fE7TO0yQ+wvQewtP6s5sX4AAAEySURBVDjL7Y5BaoQwFIZfbhDJBWbeaDp2pUj2XQjtshCyFykzFyj0CjM3aHuEnrLvPRNREUuh0C76q/H5/1/+CJB0Or+cOtjQP/BnAG3Pz32n9dxUAGoQNdxIgxaBooFMLTcvWtu87XeciRsZTrXOpKF/am2nYgPFikEVGxjD/B736RME4X2ASXSEtbjUjoDk5i3iKoDbQLutux8AvvyH7wAPq0CWhMcL7rOl9ASghjWgjpNZb6igNqZp6jodYQzP2bhNAxksIw2HhifawpgM1NBECWDEpQ3RpAZexcXjlRpYY0pPBc3YUF4iEGPO58DrDBhUgQvBe+e8x/KKBb1T5CSpwNPkGMHyHQ+e7UFekkcIwQUfyMfbNyz8RJIwMPCBG4owlaNrBMLQEJaaAR+/BHwCWwnYQHCPFSkAAAAASUVORK5CYII=",
    alt: "FO"
  }, props));
}